export default __webpack_public_path__ + "static/media/BasicFiltersImg.d9bcea88.jpg";